.rg-tick {
  margin-left: 8px;
  width: 20px;
  height: 20px;
  background: var(--primitives-colors-brand-secondary);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 10px;
    height: 10px;

    path {
      stroke: var(--semantic-colors-typography-inverse);
    }
  }
}
